import gsap from "gsap";

function circleAnime(element) {
    var thisItem = document.querySelectorAll(element);
    var tl = gsap.timeline({
        delay: 0.5
    }),
        linesNb = 60,
        linesAngleStep = 360 / linesNb,
        circlesNb = 140,
        circlesAngleStep = 360 / circlesNb;
    
    function calcCos(x, r) {
        return x * Math.cos(r * Math.PI / 180);
    }
    
    function calcSin(x, r) {
        return x * Math.sin(r * Math.PI / 180);
    }
    
    function getLinesAnimation(i) {
        var line = $(thisItem).find('.one-line').clone().removeClass('one-line').attr('id', 'line-' + i).appendTo($(thisItem).find('.all-lines')),
            rotation = linesAngleStep * i - 90,
            fromXLine = calcCos(300, rotation),
            fromYLine = calcSin(300, rotation),
            toXLine = calcCos(250, rotation),
            toYLine = calcSin(250, rotation);
    
        gsap.set(line, {
            rotation: linesAngleStep * i,
            x: fromXLine,
            y: fromYLine,
            svgOrigin: "400 400"
        });
    
        return gsap.to(line,  {
            x: toXLine,
            y: toYLine,
            duration: 0.1,
            opacity: 1
        });
    }
    
    function getCirclesAnimation(i) {
        var circle = $(thisItem).find('.one-circle').clone().removeClass('one-circle').attr('id', 'circle-' + i).appendTo($(thisItem).find('.all-circles')),
            rotation = circlesAngleStep * i - 90,
            toXCircle = calcCos(280, rotation),
            toYCircle = calcSin(280, rotation);
    
        gsap.set(circle, {
            x: toXCircle,
            y: toYCircle,
            scale: 4
        });
    
        return gsap.to(circle, {
            opacity: 0.9,
            scale: 0.8,
            duration: 0.15,
        });
    }
    
    function buildTimeline()
    {
        gsap.set(".all-lines, .all-circles, .quaters-circles", { svgOrigin: "400 400" });
    
        tl.to(".herocircle", 0.2, { opacity: 0.25 }, "start")
          .to(".quaters-circles", { duration: 0.5, opacity: 1, delay: 0.25 }, "quaters")
          .to(".quaters-circles", { duration: 2, rotation: "360deg", ease: "power4.out", delay: 0.25 }, "quaters");

        let i = null;
        
         for (i = 0; i < circlesNb; i++){
            tl.add(getCirclesAnimation(i), 1.8 + i * 0.025);
        }
    
        for (i = 0 ; i < linesNb; i++){
            tl.add(getLinesAnimation(i), 3.6 + i * 0.05);
        } 
    
        tl.to(".all-lines", { duration: 4, rotation: "18deg", ease: "power4.out", delay: 0.5 }, "rotate")
            .to(".all-circles", { duration: 4, rotation: "-18deg", ease: "power4.out", delay: 0.5 }, "rotate")
            .to(".quaters-circles", { duration: 4, rotation: "+=180deg", ease: "back.out(1.7)", delay: 0.5 }, "rotate");
    }
    
    buildTimeline();
}
// module.exports = circleAnime;

export default circleAnime;